import { useEffect, useState } from 'react';
import posthog from 'posthog-js';
import { useUser } from 'Components/Organisms/UserProvider/useUser';
import { POST_HOG_TOKEN, IS_STAGING } from 'config';

export function useFeatureFlag(flagName) {
    const [enabled, setEnabled] = useState(IS_STAGING);
    const [isloading, setIsLoading] = useState(!IS_STAGING);
    const { user } = useUser();

    useEffect(() => {
        if (IS_STAGING) return;
        if (!user.id) return;

        if (!posthog.__loaded) {
            posthog.init(POST_HOG_TOKEN, { api_host: 'https://eu.i.posthog.com' });
        }

        const checkFlag = () => {
            const isEnabled = posthog.isFeatureEnabled(flagName);
            setEnabled(isEnabled);
            setIsLoading(false);
        };

        const unsubscribe = posthog.onFeatureFlags(checkFlag);
        checkFlag();

        return () => {
            unsubscribe();
        };
    }, [flagName, user.id]);

    return { enabled, isloading };
}
